import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'
import { clearAdminAuth, getAdminToken } from './auth'

let authRedirecting = false

function redirectToLogin(message) {
  clearAdminAuth()
  if (message) {
    Message.warning(message)
  }
  if (!authRedirecting) {
    authRedirecting = true
    router.replace('/login').finally(() => {
      authRedirecting = false
    })
  }
}

function resolveErrorMessage(error) {
  if (error.code === 'ECONNABORTED') {
    return '请求超时，请稍后重试'
  }
  if (!error.response) {
    return '网络异常，请检查后台服务或本地网络'
  }
  const statusMap = {
    401: '登录状态已失效，请重新登录',
    403: '当前账号没有访问权限',
    404: '请求的接口不存在',
    500: '服务端处理失败，请稍后重试',
    502: '网关异常，请稍后重试',
    503: '服务暂时不可用，请稍后重试'
  }
  return statusMap[error.response.status] || error.message || '请求失败'
}

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 10000
})

service.interceptors.request.use(config => {
  const token = getAdminToken()
  if (token) {
    config.headers['Admin-Authorization'] = `Bearer ${token}`
  }
  return config
})

service.interceptors.response.use(
  response => {
    const payload = response.data
    if (typeof payload.code !== 'undefined') {
      if (payload.code === 200) {
        return payload.data
      }
      if (payload.code === 401) {
        redirectToLogin(payload.message || '登录状态已失效，请重新登录')
        return Promise.reject(payload)
      }
      if (payload.code === 403) {
        Message.error(payload.message || '当前账号没有权限执行这个操作')
        return Promise.reject(payload)
      }
      Message.error(payload.message || '请求失败')
      return Promise.reject(payload)
    }
    return payload
  },
  error => {
    const message = resolveErrorMessage(error)
    if (error.response && error.response.status === 401) {
      redirectToLogin(message)
    } else {
      Message.error(message)
    }
    return Promise.reject(error)
  }
)

export default service
